import { cloudChiprApi } from "../../../../../../services/cloudchipr.api";

export const getWidgetDataByViewIdSelector =
  cloudChiprApi.endpoints
    .postUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId
    .select;
